import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createMiddleware } from 'redux-beacon';
import { responsiveStoreEnhancer } from 'redux-responsive';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

import { fromJS } from 'immutable';

import { getViewInitialState } from 'src/store/view/reducer';
import eventsMap from '../middleware/gtmEventsMap';

import searchSaga from '../sagas/index';

import reducer from '../reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const gtmMiddleware = createMiddleware(eventsMap, GoogleTagManager());
const sagaMiddleware = createSagaMiddleware();
const middlewares = [gtmMiddleware, sagaMiddleware];

const enhancer = composeEnhancers(
  responsiveStoreEnhancer,
  applyMiddleware(...middlewares),
);

export const getStore = (props) => {
  const {
    logo,
    isMobile,
    isIframe,
    isWebview,
    platform,
    searchType,
    availableSearchTypes,
    marketingFiltersPreset,
    travelRequirements,
    isAppBannerEnabled,
  } = props;

  const preloadedState = {
    logo,
    view: {
      isMobile,
      isIframe,
      isWebview,
      platform,
      isWidgetShown: true,
      hideSidebar: true,
      showSubscribePopup: false,
      searchType,
      availableSearchTypes: availableSearchTypes || undefined,
      currencySymbol: '₽',
      currencyCode: 'RUB',
      isAppBannerEnabled,
      ...getViewInitialState(),
    },
    ...(marketingFiltersPreset.length
      ? {
          previousFilters: {
            isSuggestedFiltersShown: true,
            filters: marketingFiltersPreset,
          },
        }
      : {}),
    travelRequirements,
  };
  const store = createStore(reducer, fromJS(preloadedState), enhancer);
  sagaMiddleware.run(searchSaga);

  return store;
};
